import { requireAuth } from '@/router/helpers';

export default [
  {
    path: '/admin/alerts',
    name: 'AdminAlertsIndex',
    component: () => import('@/views/admin/alerts/Index.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/admin/alerts/add',
    name: 'AdminAlertsAdd',
    components: {
      default: () => import('@/views/admin/alerts/Index.vue'),
      panel: () => import('@/views/admin/alerts/AddEdit.vue'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: false, openPanel: true },
  },
  {
    path: '/admin/alerts/:id/edit',
    name: 'AdminAlertsEdit',
    components: {
      default: () => import('@/views/admin/alerts/Index.vue'),
      panel: () => import('@/views/admin/alerts/AddEdit.vue'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: false, openPanel: true },
  },
];
